'use strict';
import $ from 'jquery';

let initialized = false;

const isValidDate = date => date instanceof Date && !isNaN(date);

const cleanTimeValue = value => value.substr(value.length - 2);

const initCountowns = (selector) => {
	return $(selector).map(function() {
		const $counter = $(this);
		const dateobj = new Date($counter.data('dateobj'));
		if (!isValidDate(dateobj)) {
			console.warn('Invalid date found: ' + dateobj);
			return;
		}
		return {
			target: dateobj,
			$el: $counter
		}
	}).get();
}

export default ({
	selector = '.date-countdown',
	doneCallback = () => {}
} = {}) => {
	if (initialized) return;
	const countdowns = initCountowns(selector);

	console.log(countdowns);

	const tick = () => {
		countdowns.forEach(counter => {
			const $counter = counter.$el;
			const dd = Math.max(0, counter.target.getTime() - new Date().getTime());
			if (dd <= 0) {
				// countdown done
				doneCallback($counter);
				return;
			}
			const dhour = '0' + Math.floor(dd / (60 * 60 * 1000) * 1);
			const dmin = '0' + Math.floor(((dd % (60 * 60 * 1000 * 24)) % (60 * 60 * 1000)) / (60 * 1000) * 1);
			const dsec = '0' + Math.floor((((dd % (60 * 60 * 1000 * 24)) % (60 * 60 * 1000)) % (60 * 1000)) / 1000 * 1);
			const time = [dhour, dmin, dsec].map(cleanTimeValue).join(':');
			$counter.text(time);
			return true;
		});
	}

	tick();
	setInterval(tick, 1000);
	initialized = true;
}
